/*
 AdministratorDanych

 Tresc polityki prywatnosci Administrator danych dla wszystkich aplikacji 
  
 historia: 
  PM 2021-09-07 - start
*/

import * as React from 'react';

import { Typography } from '@material-ui/core';

class AdministratorDanych extends React.Component<any, any> {

    //PM 2021-11-05
    //variant='body2'
    //poprawka DOM
    render() {

        return (
            <React.Fragment>
                <Typography variant='body2'><b>Administrator danych</b></Typography>
                <Typography variant='body2'>
                    Administratorem danych jest firma VIRTUAL s.c. z siedzibą w Rzeszowie o adresie 35-211 Rzeszów, A.Kamińskiego 8/4. W kwestiach związanych z polityką prywatności i przetwarzania danych osobowych przez aplikację mobilną prosimy o kontakt przy pomocy korespondencji elektronicznej na adres: vsc.and.apk@gmail.com.
                </Typography>
            </React.Fragment>
        );
    }
}

export default AdministratorDanych;
